import styled from "@emotion/styled";
import colors from "styles/colors";
export const StylesMenuItem = styled.div`
  .menu-links-items {
    display: flex;
  }

  .menu-links {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 240px;

    .menu-link-item {
      flex: 1 1 auto;

      a {
        font-size: 0.875rem;
        padding: 12px 16px;

        color: ${colors["black"]};
        white-space: nowrap;
        text-decoration: none;
        display: block;
      }

      &.selected a {
        font-weight: 500;
      }

      &:hover a {
        color: ${({ hoverColor = "brand-purple" })=>colors[hoverColor]};
      }
    }
  }

  .bottom-link {
    margin: 16px;

    a {
      color: ${colors["black"]};

      &.selected {
        font-weight: 500;
      }

      &:hover {
        color: ${({ hoverColor = "brand-purple" })=>colors[hoverColor]};
      }
    }
  }
`;
